module.exports = __webpack_public_path__ + "img/wapprAttach.432b21f6.svg";